module.exports = __webpack_public_path__ + "static/img/index-icon11@2x.1fef29c8.png";